import axios from "axios";
import CryptoJS from "crypto-js";
const secretKey = process.env.REACT_APP_SECRET_KEY; // Store this securely! 
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => { 
    if ((!response.data?.status && response.data?.errorMessage === "Invalid token")||
        (!response.data?.status && response.data?.errorMessage === "Permission denied") ||
        (!response.data?.status && response.data?.message === "User logged out..!")) {
        localStorage.clear();  
        window.location.reload();
    }
    return response;
  },
  (error) => { 
    const status = error.response ? error.response.status : null; 
    if (status === 401) {
      localStorage.clear();  
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const socketEnvUrl = () => { 
  return process.env.REACT_APP_SOCKET_URL;
};  
 
 
export const getEnvUrl = () => { 
  return process.env.REACT_APP_API_CMS;
};  
export const getMediaUrl = () => { 
  return process.env.REACT_APP_MEDIA_URL;
}; 
export const getOldContentPath = () => { 
  return process.env.REACT_APP_OLD_CONTENT_PATH;
}; 
export const getToken = () => { 
    const encryptedToken = localStorage.getItem("token");
    if (!encryptedToken) return null; 
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        return null;
    }
};
export const getTeacherPortalUrl = () => { 
  return process.env.REACT_APP_TEACHER_PORTAL;
}; 
export const setToken = (token, name) => { 
  try {
    const encryptedToken = CryptoJS.AES.encrypt(token, secretKey).toString();  
    localStorage.setItem("token", encryptedToken);
    localStorage.setItem("name", name); 
    return true;
  } catch (error) {
    console.error('Error in setToken:', error);
    return false;
  }
};
export const isUserLogin = () => { 
  const encryptedToken = localStorage.getItem("token");
  if (!encryptedToken) return false; 
  try {
       CryptoJS.AES.decrypt(encryptedToken, secretKey);
      return true;
  } catch (error) {
      return false;
  } 
};
axiosInstance.defaults.baseURL = getEnvUrl();
export {axiosInstance};